<template>
    <div class="team-photo">
        <div class="team-photo__image" :style="`background-image: url('${this.image}');`" />
        <span class="team-photo__name">{{ name }}</span>
    </div>
</template>

<script>

export default {

    props: {
        name: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_team-photo.scss

@mixin circle-photo($size) {
    height: $size;
    width: $size;
    border-radius: calc(#{$size} / 2);
}

.team-photo {
    width: rem(100px);

    @include bp-min-small {
        width: rem(120px);
    }

    @include bp-min-mid {
        width: rem(80px);
    }

    @include element('image') {
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        @include circle-photo(rem(100px));

        @include bp-min-small {
            @include circle-photo(rem(120px));
        }

        @include bp-min-mid {
            @include circle-photo(rem(80px));
        }
    }

    @include element('name') {
        display: block;
        width: 100%;
        text-align: center;
        font-weight: bold;
    }
}

</style>
